import {Layout} from 'antd';

import styled from 'styled-components';

export const StyledLayoutContentWrapper = styled(Layout)`
  overflow: hidden;
`;
